import { isTodoFolderList, isTodoMyDayList, TodoListId } from 'owa-todo-list-types';
import { assertNever } from 'owa-assert';

/**
 * Get a unique key got the list used for UI purposes when
 * rendering that tasks list picker
 */
export function getElementKey(elementName: string, listId: TodoListId) {
    if (isTodoMyDayList(listId)) {
        return elementName + listId.type.toString();
    } else if (isTodoFolderList(listId)) {
        return elementName + listId.type.toString() + listId.Id.toString();
    }
    return assertNever(listId);
}
